// 介面風格（比照欣興 T 棟 IPPC）：'claude'＝橘暖風格（馬修預設，赭橘 #D4714E／米色）；'vis'＝東海冷凍 VIS（深藍 #00498A／冷灰）；'dark'＝深色
// 全站一致：由系統管理 → 系統設定 → 介面風格 決定（存後端 system_settings.branding.theme，僅 dev 可改）。
// 本機 localStorage 只當「開機快取」：頁面一載入就用它決定配色，避免先閃一次錯的顏色；
// 讀到後端設定跟快取不同時，更新快取並重新載入一次（見 syncServerTheme）。
//   - 頁面寫死的主色／背景／文字／邊框已換成 CSS 變數 var(--sw-*)（index.css 依 <html data-theme> 切換）
//   - antd 主題 token 與 designTokens.colors 需要實際色碼 → 在模組載入時依 BOOT_THEME 選一組
export type UiTheme = 'claude' | 'vis' | 'dark';

/** 馬修預設＝橘暖（維持上線前的外觀）；後端沒有設定或值不合法時都回到橘暖 */
export const DEFAULT_UI_THEME: UiTheme = 'claude';

export function toUiTheme(v: unknown): UiTheme {
  return v === 'vis' || v === 'dark' || v === 'claude' ? v : DEFAULT_UI_THEME;
}

const LS_KEY = 'ui_theme';

function readBootTheme(): UiTheme {
  try {
    return toUiTheme(localStorage.getItem(LS_KEY));
  } catch {
    return DEFAULT_UI_THEME;
  }
}

export const BOOT_THEME: UiTheme = readBootTheme();

try {
  document.documentElement.dataset.theme = BOOT_THEME;
} catch { /* 非瀏覽器環境（測試）略過 */ }

/** 後端設定的風格跟目前不同 → 寫入快取並重新載入（寫不進去就不重載，避免無限重載） */
export function syncServerTheme(serverTheme: unknown): void {
  const want = toUiTheme(serverTheme);
  if (want === BOOT_THEME) return;
  try {
    localStorage.setItem(LS_KEY, want);
    if (localStorage.getItem(LS_KEY) !== want) return;
  } catch {
    return;
  }
  window.location.reload();
}
